var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
export var CHECK_MESSAGING_ACCOUNT = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation CheckMessagingAccount($id: uuid!) {\n        check_messaging_account(id: $id) {\n            status\n            callback_url\n            callback_reason\n        }\n    }\n"], ["\n    mutation CheckMessagingAccount($id: uuid!) {\n        check_messaging_account(id: $id) {\n            status\n            callback_url\n            callback_reason\n        }\n    }\n"])));
var templateObject_1;
